import { createApp } from "vue";
import Cart from "../../vue/views/cart/CartView.vue";

const cartApp = createApp(Cart);
cartApp.mount("#root-cart-view");
